import { Breadcrumbs as MuiBreadcrumbs } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { HashLink as Link } from '~components/hash-link';
import { useReplaceSuiteStudentToCustomer } from '~containers/suite-config/suite-context';

const useStyles = makeStyles((theme) => ({
  li: {
    lineHeight: 1.71,
    fontSize: theme.typography.pxToRem(14),
    color: theme.colors.grey99,
  },

  link: {
    textDecoration: 'none',
    color: theme.colors.grey99,
    cursor: 'pointer',

    '&:hover': {
      textDecoration: 'underline',
    },
  },

  span: {
    color: theme.colors.grey66,
  },

  separator: {
    lineHeight: 1.71,
    fontSize: theme.typography.pxToRem(14),
    color: theme.colors.grey99,
  },
}));

function Breadcrumbs({ className, data }) {
  const styles = useStyles();
  const [t] = useTranslation();
  const replaceSuiteStudentToCustomer = useReplaceSuiteStudentToCustomer();

  const getCrumbLabel = useCallback(
    (crumb) => {
      if (crumb?.children) return crumb?.children;
      if (crumb?.label === 'student' || crumb?.label === 'student-details') {
        return replaceSuiteStudentToCustomer(
          t(`functions.${crumb.label}`),
          t(`functions.${crumb.label}.CUSTOMER`)
        );
      }
      return t(`functions.${crumb.label}`);
    },
    [replaceSuiteStudentToCustomer, t]
  );

  return (
    <MuiBreadcrumbs
      aria-label="breadcrumb"
      classes={{ li: styles.li, separator: styles.separator }}
      className={className}
    >
      {data.map((item, index) =>
        item.path ? (
          <Link key={index} className={styles.link} to={item.path}>
            {getCrumbLabel(item)}
          </Link>
        ) : (
          <span key={index} className={styles.span}>
            {getCrumbLabel(item)}
          </span>
        )
      )}
    </MuiBreadcrumbs>
  );
}

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      children: PropTypes.node,
      label: PropTypes.string,
      path: PropTypes.string,
    })
  ).isRequired,
};

Breadcrumbs.defaultProps = {
  className: '',
};

export default Breadcrumbs;
